import React from 'react';
import { Link as MuiLink } from '@mui/material';

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    href?: string;
};

export const markdownLinkComponents = {
    a: ({ href, children, ...props }: AnchorProps) => (
        <MuiLink
            href={href || '#'}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            color="info"
            sx={{
                '&&': { color: 'info.main' },
                '&:visited': { color: 'info.dark' },
            }}
            {...props}
        >
            {children}
        </MuiLink>
    ),
};
